interface Named {
  name: string;
}

export const sortChannels = (a: Named, b: Named) => a.name.localeCompare(b.name);
